import { render, staticRenderFns } from "./View-Serial-Number.vue?vue&type=template&id=bd0da204&scoped=true"
import script from "./View-Serial-Number.vue?vue&type=script&lang=js"
export * from "./View-Serial-Number.vue?vue&type=script&lang=js"
import style0 from "./View-Serial-Number.vue?vue&type=style&index=0&id=bd0da204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0da204",
  null
  
)

export default component.exports